var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.kindTheme === 0 || _vm.kindTheme === 2)?_c('ProductPageTheme0'):(_vm.kindTheme===1)?_c('ProductPageTheme1'):_vm._e(),_c('bottom-left-call')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }